/**
 * LaunchDarkly gate for the whole Routing V3 surface (route + sidebar entry).
 * LD key: `om_prod_915_routing_v3` — the React SDK camelCases flag keys, so
 * call sites read the camelCase form (same convention as
 * `omProd901ShippingGroups`). Default OFF: production resolves to off until
 * the per-environment targeting rules flip it.
 */
export const ROUTING_V3_FLAG = 'omProd915RoutingV3';
export const ROUTING_V3_FLAG_DEFAULT = false;

/**
 * Optional kill-switch for the Epic 04 Item Attributes filter optgroup.
 * The engine's per-item attribute evaluation is tested and QA-validated, so
 * the optgroup ships ENABLED — this flag is a retire-able kill switch
 * (default on), NOT a gate. LD key: `om_prod_915_routing_v3_item_attributes`.
 */
export const ITEM_ATTRIBUTES_FLAG = 'omProd915RoutingV3ItemAttributes';
export const ITEM_ATTRIBUTES_FLAG_DEFAULT = true;

/**
 * Gate for the Product Sub Category block/group filter variable. Routing V3
 * may ship before the catalog → orchestrator → routing-service sub-category
 * data path is deployed, so the picker entry has its own gate; the parser,
 * serializer and value widget stay on so a rule saved while the flag was on
 * still renders and round-trips. LD key: `om_tech_23894_routing_subcategory_filter`.
 * Default OFF.
 */
export const SUBCATEGORY_FILTER_FLAG = 'omTech23894RoutingSubcategoryFilter';
export const SUBCATEGORY_FILTER_FLAG_DEFAULT = false;
